import React from 'react';
import AcordeaoJogos from './acordeaoJogos';
import SelectJogos from './selectJogos';

const Jogos = ({admin}) => {
    return(
        <>
            { admin ? <SelectJogos admin={admin} /> :    
            <AcordeaoJogos admin={admin} />
        }
        </>
    )
}
    

export default Jogos;